/**
 * Adds a loading-indicator to submit buttons and handles its display states
 *
 * @param {object} options
 * @param {string|HTMLElement|jQuery} options.form - The form selector, the form element or the form jQuery element.
 * @param {string} options.loadingClass - The class to set to indicate loading.
 * @param {string} options.exclude - Selector for excluding certain submit inputs from attaching the indicator.
 * @param {string} options.namespace - The namespace under which events are attached.
 * @param {string} options.prepend HTML - that is prepended to the submit button.
 * @param {string} options.append HTML - that is appended to the submit button.
 *
 * @returns {jQuery} The form.
 */
export default function ({
    form = 'form:not([target="_blank"])',
    loadingClass = 'is-loading',
    namespace = 'form-helper',
    exclude = '',
    prepend = '',
    append = `<span class="btn__preloader">
    <span class="preloader"></span>
    </span>`
} = {}) {
    const $forms = typeof form === 'string' || form instanceof HTMLElement ? $(form) : form;

    $forms.each((index, el) => {
        let $form = $(el),
            $formSubmit = $form
                .find('[type="submit"]')
                .not('[target="_blank"]');

        if (exclude) {
            $formSubmit = $formSubmit.not(exclude);
        }

        $formSubmit.on('click.' + namespace, event => {
            event.currentTarget.classList.add('submitter');
        });

        $form.on('submit.' + namespace, () => {
            if (!$formSubmit.length) {
                return;
            }

            let $submitter = $formSubmit.filter('.submitter');

            if ($submitter.length) {
                $formSubmit = $submitter.removeClass('submitter');
            } else {
                $formSubmit = $formSubmit.last();
            }

            if ($formSubmit.is('input')) {
                // wrap it, so e.g. hover effects of the input can also effect the indicator
                $formSubmit.wrap('<span class="loading-indicator-container"></span>');

                // input[type="submit"] cannot contain child elements
                // so the loading indicator is displayed besides the input
                let $nextElement = $formSubmit.next();

                if (!$nextElement.length || !$nextElement.is('.loading-indicator')) {
                    $formSubmit = $('<span class="loading-indicator" />')
                        .insertAfter($formSubmit);
                } else {
                    $formSubmit = $nextElement;
                }
            }

            if (!$formSubmit.data('loadingInitialized')) {
                // add our pre- and append html if not already happened
                $formSubmit.data('loadingInitialized', true);

                $formSubmit
                    .prepend(prepend)
                    .append(append);

                // note: this works only, if the request was sent by jQuery, but is better than nothing
                // "native" solution would mean overwriting/extending XMLHttpRequest.prototype
                $(document).ajaxStop(() => {
                    $formSubmit.removeClass(loadingClass);
                });
            }

            // add a loading indicator to the submit
            $formSubmit.not('.' + loadingClass).addClass(loadingClass);
        });
    });

    return $forms;
}



// WEBPACK FOOTER //
// ./node_modules/@spinnwerk/form-helper/loading-indicator.js